import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Container, Grid } from "@material-ui/core";
import {
  ButtonHLPure,
  TextAreaHLPure,
  DialogSystemGLPure,
  SubtitlePageHLPure,
} from "../../pures";
import "./business-administration-disable.css";
import { businessIconDefault } from "../../../assets/logos/icons";

const BusinessAdministrationDisableView = ({
  hideShowDetails,
  selectedUser,
  saveStatusForCompany,
  token,
  handleChangeImgProfile,
  changeImgFile,
  imgProfileSubtitle,
  uploadFileCustom,
  showLoadingRequesting,
  showCompletedRequesting,
  showErrorRequesting,
  showWarningRequesting,
  toggleCompletedRequesting,
  toggleLoadingRequesting,
  toggleErrorRequesting,
  toggleWarningRequesting,
  message,
  imageProfile,
  nameComponentUser,
}) => {
  const { t } = useTranslation();
  const [commentsDisableCompany, setCommentsDisableCompany] = useState("");

  const handleChangeComments = (e) => {
    setCommentsDisableCompany(e.target.value);
  };

  const handleSave = () => {
    const body = {
      companyId: selectedUser.companyId,
      status: !selectedUser.company.status,
      deactivationReason: commentsDisableCompany,
    };

    saveStatusForCompany(token, body);
  };

  return (
    <Grid
      item
      lg={12}
      md={12}
      sm={12}
      xs={12}
      className="userAdministrationAddNewUserView-wrapper"
    >
      <>
        <Grid
          item
          lg={12}
          md={12}
          xs={12}
          sm={12}
          className="businessAdministrationDisableView-header"
        >
          <SubtitlePageHLPure
            subtitle={
              t("businessAdministrationPanelView.disableCompany") +
              " " +
              selectedUser.clientName
            }
            imgProfile={businessIconDefault}
            profileImg={selectedUser?.imgProfile || imageProfile}
            imageInfo
            tooltipShow
            openTooltipDescription={false}
            // handleChangeImage={handleChangeImgProfile}
            positionTooltip={"bottom"}
            titleTooltip={t("businessAdministrationAddressView.tooltip.img.title")}
            descriptionTooltip={t("businessAdministrationAddressView.tooltip.img.description")}
            informationIcon={false}
            uploadFile={(e) => uploadFileCustom(e)}
            changeImgFile={changeImgFile}
            justShowImg={false}
          />
        </Grid>
        <Grid
          container
          className="businessAdministrationDisableView-body"
          xs={12}
          lg={12}
          md={12}
          sm={12}
          es={12}
        >
          <>
            {/*Container primera seccion de items, fila*/}
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              className="businessAdministrationDisableView-form"
            >
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className="businessAdministrationDisableView-textAreaHLPure"
              >
                <TextAreaHLPure
                  labelTextArea={
                    selectedUser.company.status
                      ? `${t("digitalContractDashboard.questionnaires.disableReason")} *`
                      : t("businessAdministrationDisableView.reason.activation")
                  }
                  handleChangeTextArea={(e) => handleChangeComments(e)}
                  valueTextData={commentsDisableCompany}
                />
              </Grid>
            </Grid>
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              className="businessAdministrationDisableView-btnGroup"
            >
              <div
                xs={12}
                className="businessAdministrationDisableView-spaceBtns"
              >
                <ButtonHLPure
                  primary={false}
                  nameBtn={t("button.cancel")}
                  onClickBtn={hideShowDetails}
                />
              </div>
              <ButtonHLPure
                primary
                nameBtn={
                  selectedUser.company.status ? t("businessAdministrationDisableView.disable") : t("businessAdministrationDisableView.enable")
                }
                onClickBtn={handleSave}
              />
            </Grid>
          </>
        </Grid>
        <DialogSystemGLPure
          showLoadingRequesting={showLoadingRequesting}
          showCompletedRequesting={showCompletedRequesting}
          showErrorRequesting={showErrorRequesting}
          showWarningRequesting={showWarningRequesting}
          toggleLoadingRequesting={toggleLoadingRequesting}
          toggleCompletedRequesting={toggleCompletedRequesting}
          toggleErrorRequesting={toggleErrorRequesting}
          toggleWarningRequesting={toggleWarningRequesting}
          message={message}
        />
      </>
    </Grid>
  );
};

export default BusinessAdministrationDisableView;
